<template>
  <v-subheader>{{ $t('labels.deals') }}</v-subheader>
</template>

<script>
export default { name: 'DealHeader' }
</script>
